import { AxiosResponse } from "axios";
import { withPath } from "library/api/api";
import { components } from "library/api/card-management-service.generated";
import { getHref } from "../httpMethods";
import { AddressesApiResponse } from "./types.generated";

export const getAddresses = (
  tokens: string[],
): Promise<AxiosResponse<AddressesApiResponse>> =>
  getHref<AddressesApiResponse>(
    withPath(`v1/card-management/addresses?tokens=${tokens}`),
  );

export const getSingleAddress = (
  token: string,
  masked: boolean,
): Promise<
  AxiosResponse<components["schemas"]["AccountsAddressesSingleMaskedResponse"]>
> =>
  getHref<components["schemas"]["AccountsAddressesSingleMaskedResponse"]>(
    withPath(
      `v1/card-management/${token}/addresses${masked ? "?masked=true" : ""}`,
    ),
  );
